// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-34-0U";
var _3 = "priceRow-ohEP6";
export { _1 as "__esModule", _2 as "wrapper", _3 as "priceRow" }
export default { "__esModule": _1, "wrapper": _2, "priceRow": _3 }
